import { Dot } from "./dot";

export class Channel {
    class: string;
    color: string;
    dots: Array<Dot>;
    hide: boolean;
    title: string;
    total: number;
    constructor (data) {
        this.class =  data.class;
        this.color =  data.color;
        this.dots =  data.dots.map(item => new Dot(item));
        this.hide =  data.hide;
        this.title =  data.title;
        this.total =  data.total;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/stats/channel.ts